import React from "react";
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Paper
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const groups = this.props.groups;
    const generalJournal = this.props.generalJournal;
    const factories = this.props.factories;
    const selectedDate = this.props.selectedDate;
    const journalData = this.props.journalData;

    let totalCredit = 0;
    let totalDebit = 0;
    journalData.forEach(x => {
      totalCredit += x.credit
      totalDebit += x.debit
    });

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div
          style={{ fontFamily: 'sans-serif' }}
        >
          <div>
            <div style={{ fontSize: "12px" }}>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{groups[generalJournal.groupID]}</p>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{factories[generalJournal.factoryID]}</p>
              <p style={{ textAlign: 'center', fontSize: "11px" }}>MAIN CASH PAYMENT VOUCHER</p>
            </div>
            &nbsp;
            <Grid container style={{ fontSize: "12px" }}>
              <Grid container xs={8}>
                <Grid item xs={4}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Recipient</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Payable To</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Description</p>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{generalJournal.customerName + "(" + generalJournal.registrationNumber + ")"}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{generalJournal.routeManager != null ? generalJournal.routeManager : " - "}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px", fontSize: "12px", width: "90%" }}
                  >
                    <p>{journalData.length != 0 ? journalData[0].description : ""}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid container xs={4}>
                <Grid xs={6}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>V : NO</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Date</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>CHQ No</p>
                  </div>
                </Grid>

                <Grid xs={6}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{generalJournal.referenceNumber}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{(selectedDate).split('T')[0]}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{generalJournal.chequeNumber}</p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Box>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow style={{
                      borderBottom: "1px solid black",
                    }}>
                      <TableCell align={'left'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Acc Code</TableCell>
                      <TableCell align={'left'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Account Name</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >QTY</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Rate</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Dr</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Cr</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ borderBottom: '1px solid black' }}>
                    {journalData.map((data, index) => (
                      <TableRow key={index} style={{ borderBottom: "1px solid black" }}>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '0px solid black', fontSize: '11px', padding: "2px" }}>
                          {data.selected[0].ledgerAccountCode}
                        </TableCell>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '0px solid black', fontSize: '11px', padding: "2px" }}>
                          {data.selected[0].ledgerAccountName}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderTop: "0px solid black", borderLeft: '0px solid black', fontSize: '11px', padding: "2px" }}>
                          {0}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '0px solid black', fontSize: '11px', padding: "2px" }}>
                          {0}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '0px solid black', fontSize: '11px', padding: "2px" }}>
                          {data.debit != 0 ? data.debit.toFixed(2) : ''}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '0px solid black', borderRight: '0px solid black', fontSize: '11px', padding: "2px" }}>
                          {data.credit != 0 ? data.credit.toFixed(2) : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableBody>
                    <TableRow style={{ borderBottom: "1px solid black" }}>
                      <TableCell colSpan={4} style={{ fontSize: '11px', padding: '2px', border: 'none' }} />
                      <TableCell align={'right'} scope="row" style={{ border: "0px solid black", fontSize: "11px", padding: "2px" }}>
                        {totalDebit.toFixed(2)}
                      </TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "0px solid black", fontSize: "11px", padding: "2px" }}>
                        {totalCredit.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            &nbsp;
            &nbsp;
            <br />
            <br />
            <Grid container style={{ fontSize: '12px' }}>
              <Grid item xs={12}>
                <p>{generalJournal.preparedBy == null ? "-" : generalJournal.preparedBy}</p>
              </Grid>
              <Grid item xs={3} align='center'>
                <div
                  className="row"
                  align={"left"}
                >
                  Prepared By
                </div>
              </Grid>
              <Grid item xs={3} align='center'>
                <div
                  className="row"
                  align={"center"}
                >
                  Checked By
                </div>
              </Grid>
              <Grid item xs={3} align='center'>
                <div
                  className="row"
                  align={"center"}
                >
                  Approved By
                </div>
              </Grid>
              <Grid item xs={3} align='center'>
                <div
                  className="row"
                  align={"right"}
                >
                  Received by
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Paper>
    );
  }
}
